import { AlmanacFile } from 'types'

export type MinimalMediaFile = Pick<AlmanacFile, 'id' | 'thumbnail_url' | 'source_url' | 'duration'>

export interface BatchContentActionsProps {
  toggleIsSelectView?: () => void
  eventsData: any[]
  eventsInView: any[]
  eventsInViewAfterToday: any[]
  selectedEventIds: string[]
  setSelectedEventIds?: (ids: string[]) => void
  isSelectView: boolean
  selectAll?: (ids: string[]) => void
  onConfirm?: (postsCount: number) => void
}

export const platformManualSchedulingMapping = {
  facebook_post: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 9,
        to: 12,
      },
      weekends: {
        from: 10,
        to: 11,
      },
    },
  },
  facebook_story: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 12,
        to: 13,
      },
      weekends: {
        from: 10,
        to: 11,
      },
    },
  },
  instagram_post: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 10,
        to: 15,
      },
      weekends: {
        from: 10,
        to: 15,
      },
    },
  },
  crosspost_post: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 10,
        to: 15,
      },
      weekends: {
        from: 10,
        to: 15,
      },
    },
  },
  video_crosspost_post: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 10,
        to: 15,
      },
      weekends: {
        from: 10,
        to: 15,
      },
    },
  },
  instagram_story: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 10,
        to: 14,
      },
      weekends: {
        from: 10,
        to: 14,
      },
    },
  },
  instagram_reel: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 14,
        to: 17,
      },
      weekends: {
        from: 14,
        to: 17,
      },
    },
  },
  tiktok_post: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 14,
        to: 17,
      },
      weekends: {
        from: 14,
        to: 17,
      },
    },
  },
  youtube_short: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 14,
        to: 17,
      },
      weekends: {
        from: 14,
        to: 17,
      },
    },
  },
  twitter_post: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 9,
        to: 12,
      },
      weekends: {
        from: 9,
        to: 12,
      },
    },
  },
  twitter_thread: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 9,
        to: 12,
      },
      weekends: {
        from: 9,
        to: 12,
      },
    },
  },
  linkedin_post: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 10,
        to: 11,
      },
      weekends: {
        from: 10,
        to: 11,
      },
    },
  },
  newsletter: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 8,
        to: 15,
      },
      weekends: {
        from: 8,
        to: 15,
      },
    },
  },
  blog_post: {
    best_times_of_day_to_post: {
      weekdays: {
        from: 9,
        to: 14,
      },
      weekends: {
        from: 9,
        to: 14,
      },
    },
  },
}
